import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestFoldersPost = {
    path: "/folders",
    method: RouteHttpVerb.POST
};
export { locationRestFoldersPost };
